export enum TempCheckCounterStatus {
  Ready = 'Ready',
  Checked = 'Checked',
}
